import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }

import { InputRow, Combobox } from '@/components/ui/form';
    import { useEconomicAccountData } from '@/composables/useEconomicAccountData';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData, ViiaAccount } from '@/types';
    import { useJournalsData } from '@/composables/useJournalsData';
    import { useCashBookTypesData } from '@/composables/useCashBookTypeData';
import { computed } from 'vue';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'TransferEconomicForm',
  props: {
    form: {},
    dbAccount: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    

    const { journals, isLoadingJournals } = useJournalsData(companyId.value);
    const { cashBookTypes, isLoadingCashBookTypes } = useCashBookTypesData();
    const { accounts, isLoadingAccounts } = useEconomicAccountData(companyId.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.dbAccount.contra_account_nr)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 0,
          form: _ctx.form,
          name: "contra_account_nr",
          label: "viia.accounts.attach"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Combobox), {
              modelValue: _ctx.form.contra_account_nr,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.contra_account_nr) = $event)),
              options: _unref(accounts),
              translate: false,
              placeholder: _ctx.$t('viia.accounts.attach'),
              "label-by": "number_and_name",
              "value-by": "accountNumber",
              loading: _unref(isLoadingAccounts),
              "show-remove-button": false
            }, null, 8, ["modelValue", "options", "placeholder", "loading"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "cashbook_id",
      label: "viia.transactions.cashbook"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.cashbook_id,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.cashbook_id) = $event)),
          options: _unref(journals),
          translate: false,
          placeholder: _ctx.$t('viia.transactions.cashbook'),
          "label-by": "name",
          "value-by": "number",
          loading: _unref(isLoadingJournals),
          "show-remove-button": false
        }, null, 8, ["modelValue", "options", "placeholder", "loading"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "cashBookType",
      label: "viia.transactions.cashbook-type"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.cashBookType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.cashBookType) = $event)),
          options: _unref(cashBookTypes),
          translate: false,
          placeholder: _ctx.$t('viia.transactions.cashbook-type'),
          "label-by": "text",
          "value-by": "id",
          loading: _unref(isLoadingCashBookTypes),
          "show-remove-button": false
        }, null, 8, ["modelValue", "options", "placeholder", "loading"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})